import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { QuestionType } from '@empathy/survey/base';
import { Question } from '@empathy/survey-core';

@Component({
  selector: 'empathy-error-container',
  templateUrl: 'error-container.component.html',
  styleUrls: ['./error-container.component.scss']
})
export class ErrorContainerComponent {
  @Input() question: Question;
  @Input() questionCtrl: AbstractControl;

  questionType = QuestionType;
}
